<template>
  <v-dialog
    scrollable
    v-model="visable"
    max-width="600px"
    :persistent="true"
    content-class="elevated-dialog"
  >
    <v-card class="professional-review-dialog deep-ocean-theme">
      <v-card-title class="dialog-header">
        <span class="dialog-title">
          {{ loading ? '正在提交...' : '审核' }}
        </span>
      </v-card-title>

      <v-divider class="content-divider"/>
      <v-progress-linear class="progress-bar" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text class="dialog-content">
        <p class="subheading">{{ message }}</p>
        <v-divider class="pb-1"/>
        <p class="section-title">审核结论</p>
        <v-radio-group v-model="status" column hide-details class="radio-group">
          <v-radio
            v-for="a in actions"
            :label="a.name"
            :value="a.action"
            :key="a.dbid"
            class="radio-item"
          />
        </v-radio-group>
        <v-textarea
          label="审核意见"
          v-model="note"
          counter="200"
          class="review-textarea mt-4"
          persistent-hint
        />
      </v-card-text>
      <v-card-actions class="dialog-actions">
        <v-spacer/>
        <v-btn
            text
            @click.native="$emit('input', false)"
            class="cancel-btn"
        >
          <v-icon left>close</v-icon>
          取消
        </v-btn>
        <v-btn
            color="primary"
            @click.native="onSubmit"
            class="submit-btn"
            :disabled="loading"
            depressed
            dark
        >
          <v-icon left>check</v-icon>
          {{ loading ? '提交中...' : '提交' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    model: {
      prop: 'visable',
      event: 'input'
    },

    props: ['visable', 'message', 'uri', 'dbid', 'actions'],

    data() {
      return {
        loading: false,
        status: '',
        note: ''
      }
    },



    methods: {
      /**
       * **************************************************************
       * 异步数据请求
       */
      onSubmit() {
        //如果没有选择审核动作，则进行提示，选择了审核动作，继续执行后续代码
        if (this.status) {
          //window.console.log("this.uri")
          //window.console.log(this.uri)
          this.loading = true;
          const param = window.xutil.param("note", this.note);
          this.axios.put(`${this.uri}/${this.status}/${this.dbid}`, param)
              .then(rsp => {
                // 填充对话框
                this.$emit('ok', rsp.data);
                this.$emit('input', false);
                this.loading = false;
              });
        }
        else
          {
            alert("请选择具体操作！")
          }
      }
    }
  }
</script>
<style>
/* 深海蓝主题 */
.deep-ocean-theme {
  border-radius: 12px !important;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2) !important;
}

/* 标题栏 - 深海蓝渐变 */
.dialog-header {
  background: linear-gradient(135deg, #4b6cb7 0%, #182848 100%);
  min-height: 36px !important;
  padding: 8px 24px 2px !important;
}

.dialog-title {
  color: white !important;
  font-size: 20px !important;
  font-weight: 500;
  letter-spacing: 0.5px;
  display: block;
  width: 100%;
  margin-bottom: 16px;
}

.progress-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  margin: 0;
  width: 100%;
}

/* 内容区域 */
.dialog-content {
  padding: 24px !important;
  background-color: #f8fafc;
}

.message-text {
  font-size: 15px;
  color: #555;
  line-height: 1.6;
  margin-bottom: 16px;
}

.content-divider {
  margin: 16px 0;
  border-color: rgba(0, 0, 0, 0.08) !important;
}

.section-title {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin-bottom: 12px;
}

/* 表单元素样式 */
.radio-group {
  margin-top: 8px;
}

.radio-item {
  margin-bottom: 8px;
}

.review-textarea >>> .v-input__slot {
  border-radius: 8px !important;
  border-color: #e0e0e0 !important;
  transition: all 0.3s;
}

.review-textarea >>> .v-input__slot:hover {
  border-color: #bdbdbd !important;
}

.review-textarea >>> .v-input__slot:focus-within {
  border-color: #4b6cb7 !important;
  box-shadow: 0 0 0 2px rgba(75, 108, 183, 0.2);
}

.form-card {
  background: transparent !important;
}

.form-input >>> .v-input__slot {
  border-radius: 6px !important;
}

.uploader {
  border: 1px dashed #e0e0e0;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.3s;
}

.uploader:hover {
  border-color: #4b6cb7;
  background: rgba(75, 108, 183, 0.03);
}

/* 按钮组 */
.dialog-actions {
  padding: 16px 24px !important;
  border-top: 1px solid #eef2f6;
  background-color: white;
}

.cancel-btn {
  color: #666 !important;
  min-width: 100px;
  height: 42px;
  border-radius: 6px;
  transition: all 0.3s;
  font-weight: 500;
}

.cancel-btn:hover {
  background: rgba(0, 0, 0, 0.03) !important;
  color: #333 !important;
}

.submit-btn {
  min-width: 120px;
  height: 42px;
  border-radius: 6px;
  background: linear-gradient(135deg, #4b6cb7 0%, #182848 100%);
  color: white !important;
  box-shadow: 0 2px 8px rgba(75, 108, 183, 0.3);
  transition: all 0.3s;
  font-weight: 500;
}

.submit-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(75, 108, 183, 0.4);
}

.submit-btn.v-btn--disabled {
  background: #e0e0e0 !important;
  box-shadow: none !important;
  color: #999 !important;
}
</style>
